import CryptoJS from 'crypto-js';

// 암호화 키 (환경변수에서 가져오거나 기본값 사용)
// 실제 운영 환경에서는 반드시 환경변수로 관리해야 함
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'moi-secure-key-2024-default-32ch';
const IV_LENGTH = 16;

/**
 * AES256 암호화
 * @param plainText 암호화할 평문
 * @returns 암호화된 문자열 (Base64)
 */
export const encrypt = (plainText: string): string => {
    if (!plainText) return '';

    try {
        // 랜덤 IV 생성
        const iv = CryptoJS.lib.WordArray.random(IV_LENGTH);

        // 키를 32바이트로 맞춤 (AES-256)
        const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY.padEnd(32, '0').substring(0, 32));

        // AES 암호화
        const encrypted = CryptoJS.AES.encrypt(plainText, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        // IV + 암호문을 합쳐서 Base64로 반환
        const combined = iv.concat(encrypted.ciphertext);
        return CryptoJS.enc.Base64.stringify(combined);
    } catch (error) {
        console.error('Encryption error:', error);
        return '';
    }
};

/**
 * AES256 복호화
 * @param encryptedText 암호화된 문자열 (Base64)
 * @returns 복호화된 평문
 */
export const decrypt = (encryptedText: string): string => {
    if (!encryptedText) return '';

    try {
        // Base64 디코딩
        const combined = CryptoJS.enc.Base64.parse(encryptedText);

        // IV와 암호문 분리
        const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, IV_LENGTH / 4), IV_LENGTH);
        const ciphertext = CryptoJS.lib.WordArray.create(
            combined.words.slice(IV_LENGTH / 4),
            combined.sigBytes - IV_LENGTH
        );

        // 키를 32바이트로 맞춤
        const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY.padEnd(32, '0').substring(0, 32));

        // AES 복호화
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: ciphertext } as CryptoJS.lib.CipherParams,
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        console.error('Decryption error:', error);
        return '';
    }
};

/**
 * 민감정보 여부 확인
 */
export const isSensitiveField = (fieldName: string): boolean => {
    const sensitiveFields = [
        'userId',
        'email',
        'phoneNumber',
        'phone',
        'mobile',
        'birthDate',
        'birth',
        'address',
        'realName',
        'name'
    ];
    return sensitiveFields.includes(fieldName);
};
